import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { catchError, finalize, map } from "rxjs/operators";
import { IAgentApplication } from "../shared/models/agentApplication.models";
import { AgentApplicationService } from "../shared/services/api/agent-application.service";
import { AppLoadError } from "../shared/models";

@Injectable({
  providedIn: "root",
})
export class AgentApplicationStoreService {
  private _agentApplications = new BehaviorSubject<IAgentApplication[]>([]);
  private _loading = new BehaviorSubject<boolean>(false);
  private _error = new BehaviorSubject<AppLoadError | null>(null);

  // Observables for components to subscribe to
  agentApplications$: Observable<IAgentApplication[]> =
    this._agentApplications.asObservable();
  loading$: Observable<boolean> = this._loading.asObservable();
  error$: Observable<AppLoadError | null> = this._error.asObservable();

  // get current value
  get agents() {
    return this._agentApplications.getValue();
  }

  constructor(private service: AgentApplicationService) {}

  selectAgents(): Observable<IAgentApplication[]> {
    return this.agentApplications$.pipe(map((agents) => agents));
  }

  // Select the loading state
  selectLoading(): Observable<boolean> {
    return this.loading$.pipe(map((loading) => loading));
  }

  // Select the error state
  selectError(): Observable<AppLoadError | null> {
    return this.error$.pipe(map((error) => error));
  }

  /**
   * Load Agent Applications
   */
  loadAgentApplications(): Observable<IAgentApplication[]> {
    this._loading.next(true);
    this._error.next(null);

    return this.service.loadAgentApplications().pipe(
      map((applications: IAgentApplication[]) => {
        this._agentApplications.next(applications);
        return applications;
      }),
      catchError((error) => {
        const errorMessage =
          error?.message || "Failed to load agent applications";
        this._error.next(errorMessage);
        return of(null);
      }),
      finalize(() => {
        this._loading.next(false);
      })
    );
  }

  /**
   * Get Agent Application by ID
   */
  getAgentApplicationById(id: string): IAgentApplication | undefined {
    const currentApplications = this._agentApplications.getValue();
    return currentApplications.find((app) => {
      console.log(app);

      return app.appId === id;
    });
  }

  /**
   * Clear error
   */
  clearError(): void {
    this._error.next(null);
  }
}
